<footer>
  <div class="footer-bar-container">
  </div>
  <div class="footer-links-container">
    <div class="general-header">{{header}}</div>
    <div class="contact-container double-even">
      <div class="links">
        <a
        [href]="emailLink"
        target="blank"
        >{{emailText}}</a>
        <div class="divider">|</div>
      </div>
      <div class="links">
        <a href="tel:{{ contactInfo.tel }}" class="phone">{{ contactInfo.tel }}</a>
      </div>
    </div>
      <div class="hours">{{ contactInfo.hours }}</div>

        <div class="multi-link-container">
            <div class="multi-link-item" *ngFor="let item of content index as i">
              <a target="blank" [href]="item.url">{{ item.name }}</a>
              <div *ngIf="i !== 6" class="multi-link-divider">|</div>
            </div>
        </div>
        
        <div class="legal-container">
          <address class="legal">
            Copyright &copy; 2004 - {{ currentYear }} Symetra Life Insurance Company, 777 108th Ave NE, Suite 1200, Bellevue,
            WA 98004. All rights reserved. Symetra® is a registered service mark of Symetra Life Insurance Company.
          </address>
        </div>
      </div>
</footer>
